<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="text"
    track-by="value"
    :options="options"
    :searchable="false"
    :disabled="!editable"
    :allow-empty="false">
    <template #placeholder>
      {{ $t('common.SelectOne') }}
    </template>
  </v-multiselect>
</template>
<script>
export default {
  name: 'CustomerRelationshipInput',
  props: {
    value: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      options: [
        { value: '', text: this.$t('common.None') },
        { value: 'REQUESTED', text: this.$t('customerRelationshipStatus.REQUESTED') },
        { value: 'ACCEPTED', text: this.$t('customerRelationshipStatus.ACCEPTED') },
      ]
    };
  },
  mounted() {
  },
  computed: {
    fieldModelValue: {
      get() {
        if (!this.value) this.$emit('input', '');
        return (
          this.options.filter((x) => x.value === this.value)
          || this.options.filter((x) => x.value === '')
        );
      },
      set(newValue) {
        this.$emit('input', newValue.value);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
